export default "__VITE_ASSET__Cdt$UK3f__"